import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { StorageService } from '../storage/storage.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  storageService: StorageService = inject(StorageService);

  constructor(
    private http: HttpClient
  ) { }


  /**
   * Get Redirect URL
   */
  getRedirectUrl(): Observable<{ state: string, url: string }> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get<{ state: string, url: string }>(`${environment.api.baseUrl}/tiktok-account/oauth`); // <---- Python API
  }


  /**
   * Exchange code for token TikTok
   */
  exchangeCodeForTokenTikTok(code: string) {
    console.log('TikTok -> exchangeCodeForToken() ---->');

    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    const body = {
      code: code,
      businessId: this.storageService.get('businessId'),
      externalId: this.storageService.get('externalId')
    }

    // return this.http.post<any>(`${environment.api.baseUrl}/tokens/exchange-code/tiktok`, body, { headers }); <---- Nest API
    return this.http.post<any>(`${environment.api.baseUrl}/tiktok-account/exchange-code`, body, { headers }); // <---- Python API
  }


  /**
   * Exchange code for token Instagram
   */
  exchangeCodeForTokenInstagram(code: string) {
    console.log('Instagram -> exchangeCodeForToken() ---->');

    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    const body = {
      code: code,
      businessId: this.storageService.get('businessId'),
      externalId: this.storageService.get('externalId')
    }

    return this.http.post<any>(`${environment.api.baseUrl}/instagram-account/exchange-code`, body, { headers }); // <---- Python API
  }

   /**
   * Exchange short for long token Meta / FB Instagram
   */
   exchangeShortForLongTokenInstagram(access_token: string) {
    console.log('Instagram -> exchangeShortForLongTokenInstagram() ---->');

    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    const body = {
      access_token,
      businessId: this.storageService.get('businessId'),
      externalId: this.storageService.get('externalId')
    }

    return this.http.post<any>(`${environment.api.baseUrl}/fb-instagram-account/exchange-code`, body, { headers }); // <---- Python API
  }
}
